import { Skeleton } from '@acctglobal/skeleton'
import { Button } from '@faststore/ui'
import { useLocation } from '@reach/router'
import { MapPin } from 'phosphor-react'
import React, { useState, useEffect } from 'react'

import ArrowIcon from '../../../../../assets/ArrowIcon'
import { WarningIcon } from '../../../../../assets/WarningIcon'
import { HAS_WINDOW } from '../../../../../constants'
import { useRegionalizationContext } from '../../../../../contexts/RegionalizationContext'
import useWindowDimensions from '../../../../../hooks/useWindowDimensions'
import '../../navbar.scss'

export const RegionalizationInfos = () => {
  const [isVisible, setIsVisible] = useState(true)

  const {
    city,
    uf,
    setOpenRegionModal,
    deliveryInfos,
    regionalized,
    pickupName,
    pickupTimes,
  } = useRegionalizationContext()

  const { isMobile } = useWindowDimensions()

  const location = useLocation()
  const hiddenRegionalizationInfos =
    location.pathname.includes('/restricao-alimentar') ||
    location.pathname.includes('/busca-multipla')

  const isDelivery = regionalized === 'delivery'
  const loading = city === null && uf === null

  const navbarGeolocationClass = regionalized
    ? 'navbar__geolocation delivery-proximity'
    : 'navbar__geolocation warning'

  useEffect(() => {
    if (!HAS_WINDOW || !isMobile) {
      return
    }

    const handleScroll = () => {
      const scrollPosition = window.scrollY

      setIsVisible(scrollPosition === 0)
    }

    window.addEventListener('scroll', handleScroll)

    return () => window.removeEventListener('scroll', handleScroll)
  }, [HAS_WINDOW && window.scrollY, isMobile])

  if (loading) {
    return (
      <div className="regionalization-infos-skeleton">
        <Skeleton height={42} backgroundColor="var(--color-warning-faded)" />
      </div>
    )
  }

  if (!isVisible || hiddenRegionalizationInfos) {
    return null
  }

  return (
    <div className={navbarGeolocationClass}>
      <div className="grid-content">
        <div className="delivery-local">
          {regionalized ? (
            isMobile && (
              <>
                <MapPin size={20} />
                <div>
                  <p>
                    <span className="label-region">
                      {isDelivery ? 'Enviar para' : 'Retirar em'}:&nbsp;
                    </span>
                    <span className="container-region-text">
                      {isDelivery ? (
                        <span style={{ display: 'inline-block' }}>
                          {city}- {uf}
                        </span>
                      ) : (
                        <span className="city">{pickupName}</span>
                      )}
                      <Button onClick={() => setOpenRegionModal?.(true)}>
                        <ArrowIcon rotate="Down" />
                      </Button>
                    </span>
                  </p>
                  <p className="message-delivery">
                    {isDelivery
                      ? `Entrega a partir de ${deliveryInfos?.shippingEstimate
                          ?.replaceAll('m', ' min')
                          .replaceAll('bd', ' dias')}`
                      : `Retiradas entre ${pickupTimes?.openingTime}h e ${pickupTimes?.closingTime}h`}
                  </p>
                </div>
              </>
            )
          ) : (
            <div className="unregionalized">
              <WarningIcon />
              <Button
                onClick={() => {
                  setOpenRegionModal?.(true)
                }}
              >
                Escolha o local de entrega ou retirada
              </Button>
              <span className="message-warning">
                &nbsp;- preços e estoque podem variar de acordo com sua
                localização
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
